export enum BreedId {
    HOSTEIN = 'c38944e8-9406-11ec-8698-42010a9e0070'
}
